var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalSettingsDimmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83452 13.534C3.76962 14.3327 5.17953 14.3327 7.99935 14.3327C10.8191 14.3327 12.2291 14.3327 13.1641 13.534C13.2969 13.4206 13.4206 13.2969 13.534 13.1641C14.3327 12.2291 14.3327 10.8191 14.3327 7.99935C14.3327 5.17953 14.3327 3.76962 13.534 2.83452C13.4206 2.70174 13.2969 2.57807 13.1641 2.46466C12.2291 1.66602 10.8191 1.66602 7.99935 1.66602C5.17953 1.66602 3.76962 1.66602 2.83452 2.46466C2.70174 2.57807 2.57807 2.70174 2.46466 2.83452C1.66602 3.76962 1.66602 5.17953 1.66602 7.99935C1.66602 10.8191 1.66602 12.2291 2.46466 13.1641C2.57807 13.2969 2.70174 13.4206 2.83452 13.534Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 13.3327L13.3327 2.66602",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79883 10.5354L10.5373 1.79688",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2034 5.46289L5.46484 14.2014",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.3333L14.3333 9",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 6.99935L6.99935 1.66602",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalSettingsDimmed);
export default __webpack_public_path__ + "static/media/personal_settings_dimmed.8eb29e5ae5b1054ef67e154b89581894.svg";
export { ForwardRef as ReactComponent };